//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    position: relative;
    z-index: 90;
    & button {
        position: relative;
        z-index: 2;
    }
`;
export const OptionList = styled.div`
    position: absolute;
    top: 100%;
    width: 100%;
    overflow: hidden;
    visibility: hidden;
    ul {
        padding: 0;
        margin: 0;
        margin-top: 6px;
        z-index: 1;
        border-radius: 4px;
        background-color: var(--light-1);
        list-style: none;
        transition: 0.4s;
        transform: translateY(-120%);
    }
    &.visible {
        visibility: visible;
        & ul { transform: translateY(0); }
    }
`;
export const OptionListItem = styled.li`
    width: 100%;
    border-radius: 0px;
    padding: 16px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: var(--dark-4);
    transition: 0.35s;
    cursor: pointer;
    &.big {
        padding: 16px;
    }
    &.medium {
        padding: 10px 15px;
    }
    &:hover {
        background-color:var(--light-blue-1);
    }
    &:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }
    &:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
    }
`;